import { DownloadFormatToMimeType } from '../../../../../constants/downloadFormatToMimeType'
import { convertBase64ToBlob } from './convertBase64ToBlob'

export const ensureBlobFromResponse = async (data: Blob, mime: string): Promise<Blob> => {
  const text = await data.text()

  const isMimeTypeXlsx = mime === DownloadFormatToMimeType.xlsx

  if (isMimeTypeXlsx) {
    return convertBase64ToBlob(text, mime)
  }

  const arrayBuffer = await data.arrayBuffer()
  return new Blob([arrayBuffer], { type: mime })
}
